import React from 'react'
import { Project } from 'src/core/models'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { ProjectDetailsCollapse } from '../index'
interface PropsType {
  project: Project
}

const ProjectDetailsDescription: React.FC<PropsType> = ({ project }) => {
  const { t, i18n: { language } } = useTranslation()

  const getProjectDescription = () => {
    if (!project.has_trans_descriptions) return project.description
    const defaultLanguage = language ? language : 'en'
    const description = project.descriptions?.find(desc => desc.language === defaultLanguage)
    const defaultDescription = project?.descriptions?.find(desc => desc.language === 'en')
    return description?.text?.trim() ? description?.text : defaultDescription.text
  }

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.Description')} strong/>}>
      <div dangerouslySetInnerHTML={{
        __html: getProjectDescription()
      }}
      />
    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsDescription
